(function () {
  class Shaker extends PIXI.Container {
    constructor(objectId, threshold, magnitude) {
      super();

      this._objectId = objectId;
      this._threshold = threshold;
      this._dir = 0;
      this._magnitude = magnitude;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      this._object = resourceManager.get(this._objectId);
    }

    doShake(time, callback) {
      let timeToShake = 1500;
      if (time) {
        timeToShake = time;
      }
      this._callback = callback;
      this.shake();
      const self = this;
      this._overallTimer = timerManager.addTimeout(timeToShake, function () {
        if (callback) {
          callback();
        }
        timerManager.stop(self.shakeTimer);
        const startPos = layoutController.getCurrentPosition(self._objectId);
        self._object.position.setX(startPos.x);
      });
    }

    shake() {
      if (this._dir > 0) {
        this._dir = -1;
      } else {
        this._dir = 1;
      }
      const self = this;
      this.shakeTimer = timerManager.addTimer(
        50,
        function (progress) {
          const startPos = layoutController.getCurrentPosition(self._objectId);
          const endX = startPos.x + self._magnitude * self._dir;
          const distance = (endX - startPos.x) * progress;
          self._object.position.setX(startPos.x + distance);
        },
        function () {
          const startPos = layoutController.getCurrentPosition(self._objectId);
          self._object.position.setX(startPos.x);
          self.shake();
        }
      );
    }

    skip() {
      timerManager.stop(this._overallTimer);
      timerManager.stop(this.shakeTimer);
      if (this._callback) {
        this._callback();
      }
    }
  }

  var shakerCreator = function (json) {
    return new Shaker(json.objectId, json.threshold, json.magnitude);
  };

  var shakerInitialiser = function (json, shaker) {};

  var shakerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "shaker",
    shakerCreator,
    shakerInitialiser,
    shakerFilesRequired
  );
})();
